import { appRef } from './app'

export function isAuthenticated() {
    return appRef.state.user !== undefined
}
